<template>
    <li
        class="episodes-list-item"
    >
        <div class="episodes-featured-column">
            &nbsp;
        </div>
        <div class="episodes-title-column">
            <a
                href="#"
                class="episodes-title"
                :title="episode.title"
                @click.prevent=""
            >
                {{ episode.title }}
            </a>

            <div class="episode-modal-publication-timestamp episode-status">
                <i class="status-icon far fa-history" />
                Processing...
            </div>
        </div>
        <div class="episodes-season-episode-column">
            {{ seasonEpisode }}
        </div>
        <div class="episodes-duration-column">
            <span
                class="episodes-duration"
                :class="{ 'empty-value': ! episode.duration }"
            >
                {{ episode.durationFormatted || '&ndash;' }}
            </span>
        </div>
        <div class="episodes-total-listens-column">
            <span
                class="episodes-total-listens"
                :class="{ 'empty-value': ! episode.totalListens }"
            >
                {{ episode.totalListens || '&ndash;' }}
            </span>
        </div>
        <div class="episodes-actions-column">
            <button
                class="episodes-edit-button"
                @click="episodeModal.open()"
            >
                <i class="far fa-pen" />
                Edit
            </button>
        </div>
    </li>
</template>
<script>
import episodeModal from '@/utils/episodeModal';

export default {
    props: {
        episode: {
            required: true,
            type: Object,
        },

        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        episodeModal,
    }),

    computed: {
        /**
         * Computes value for "Season/Episode" column.
         *
         * @returns {string} Value for "Season/Epsode" column.
         */
        seasonEpisode() {
            if ('serial' === this.show.podcastType) {
                return `${this.episode.seasonNo} / ${this.episode.episodeNo}`;
            }

            return this.episode.episodeNo;
        },
    },
};
</script>
